import {post} from "../../../DAL/data-provider";
import {ProductsListInputParam, Response} from "../interfaces";


export const sendCodeEmail = async (userEmail:string,_products:ProductsListInputParam[],recaptchaVersion:number,captchaCode:string) => {
    return post('/api/misc/SystemBuilder/send-code-email',
        {  Email:userEmail,
                sendData :{products:_products},
                RecaptchaVersion:recaptchaVersion,
                CaptchaCode:captchaCode
            });
};
export const getSblCost = async (_products:ProductsListInputParam[]): Promise<Response> => {
    return post('/api/misc/SystemBuilder/get-sbl-cost',
        {products:_products});
};

